import { useTranslation } from 'react-i18next'
import { Alert } from '@/components'
import { ContentPlaceholder } from '@/components/molecules'
import { WIZARD_STORAGE_KEY } from '@/constants/walkthrough'

export const ComingSoonContainer: React.FC = () => {
    const { t } = useTranslation('translations')

    return (
        <div className="flex h-full flex-col p-6">
            <Alert
                variant="info"
                title={t('coming_soon_container.alert_title')}
                description={t('coming_soon_container.alert_description')}
                linkDescription={t(
                    'coming_soon_container.alert_link_description'
                )}
                onClickLink={() => {
                    localStorage.removeItem(WIZARD_STORAGE_KEY)
                    window.dispatchEvent(
                        new CustomEvent('restartAgentBrokerWizard')
                    )
                }}
            />
            <ContentPlaceholder
                name="content-placeholder"
                title={t('coming_soon_container.content_placeholder.title')}
                description={t(
                    'coming_soon_container.content_placeholder.description'
                )}
                illustrationSrc="/assets/under-construction-illustration.svg"
                className="mt-6 flex-1 whitespace-pre-line border-0 bg-white shadow-none"
            />
        </div>
    )
}
